import { render, staticRenderFns } from "./Subtitle.vue?vue&type=template&id=f7386ec0&scoped=true"
var script = {}
import style0 from "./Subtitle.vue?vue&type=style&index=0&id=f7386ec0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7386ec0",
  null
  
)

export default component.exports